import styled from 'styled-components';

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 44px;
  border: 1px solid #E3E3E3;

  border-radius: ${p => p.right ? '0px 6px 6px 0px' : '6px 0px 0px 6px'};
  border-left: ${p => p.right ? 'none' : '1px solid #E3E3E3'};
  background-color:${p => p.selected ? "#F4F4F4" : "white"};

  font-weight: ${p => p.selected ? 600 : 400};
  font-size: 14px;
  color: ${window?.settings?.secondary_color ?? '#04333b'};

  cursor: pointer;
`;
